import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface HeaderRightSlotContextType {
  slot: React.ReactNode;
  setSlot: (node: React.ReactNode) => void;
}

const HeaderRightSlotContext = createContext<HeaderRightSlotContextType | undefined>(undefined);

export function HeaderRightSlotProvider({ children }: { children: ReactNode }) {
  const [slot, setSlotState] = useState<React.ReactNode>(null);
  const setSlot = useCallback((node: React.ReactNode) => {
    setSlotState(node);
  }, []);
  const value = { slot, setSlot };
  return (
    <HeaderRightSlotContext.Provider value={value}>
      {children}
    </HeaderRightSlotContext.Provider>
  );
}

export function useHeaderRightSlot(): HeaderRightSlotContextType {
  const ctx = useContext(HeaderRightSlotContext);
  if (ctx === undefined) {
    throw new Error('useHeaderRightSlot must be used within HeaderRightSlotProvider');
  }
  return ctx;
}
